<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-01-13 21:06:06
 * @LastEditors: 诺
 * @LastEditTime: 2023-01-06 16:12:37
-->

<template>
  <div class="ActBaseBottom" ref="box" :style="bgStyle">
    <div class="shareBtn" v-if="configInfo.shareSwitch == 1 && showShareBtn">
      <div class="shareImg" v-if="configInfo.shareType==2"  @click="$emit('showShare')">
        <img :src="configInfo.shareButtonStyleImg" />
      </div>
      <div
        v-else
        @click="$emit('showShare')"
        class="default act-text-stroke"
        :style="{
          backgroundColor: configInfo.buttonBackgroundColour,
          color: configInfo.buttonTextColour,
        }"
      >
        {{configInfo.shareBtnText||'呼朋唤友'}}
      </div>
    </div>
    {{ configInfo.disclaimer || "本次活动最终解释权归开发商所有。" }}
  </div>
</template>
<script>
export default {
  props: {
    configInfo: Object,
    showShareBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    bgStyle(){
      const {backgroundColour} = this.configInfo
      return {
        background: `linear-gradient(180deg, ${backgroundColour}00 0%, ${backgroundColour} 100%)`,
      }
      
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.ActBaseBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* height: 20px; */
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 18px;
  z-index: 100;
}

.shareBtn {
  width: 278px;
  margin: 26px auto 16px;

  .default {
    width: 278px;
    height: 48px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 100px;
    text-align: center;
    line-height: 48px;
    font-size: 20px;
    font-weight: 600;
    animation: debounce 5s ease infinite;
  }

  .shareImg {
    width: 278px;
    height: 48px;

    img {
      width: 278px;
      height: 48px;
      object-fit: contain;
    }
  }
}

@keyframes debounce {
  0% {
    transform: rotate(-5deg);
  }
  4% {
    transform: rotate(5deg);
  }
  8% {
    transform: rotate(-5deg);
  }
  12% {
    transform: rotate(5deg);
  }
  16% {
    transform: rotate(-5deg);
  }
  20% {
    transform: rotate(5deg);
  }
  25% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
